import { render, staticRenderFns } from "./discovery-zoomer.vue?vue&type=template&id=2f971822&scoped=true&"
import script from "./discovery-zoomer.vue?vue&type=script&lang=js&"
export * from "./discovery-zoomer.vue?vue&type=script&lang=js&"
import style0 from "./discovery-zoomer.vue?vue&type=style&index=0&id=2f971822&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f971822",
  null
  
)

export default component.exports